export default __webpack_public_path__ + "static/media/icon-security-small-active-copy.fc96a91f.svg";